import React from 'react'
import { ImportantNotesInfoData, ImportantNotesInfoWrapper } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { ImportantNoteToProfessionalType } from '../../../../types';

const ImportantNotesInfo = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);
  return (
    <ImportantNotesInfoWrapper>
      <p>Important things about you to know during the duration of the consulting process</p>
      {selectedClient?.importantNotesToProfessional?.length ?
        selectedClient?.importantNotesToProfessional?.map((importantNote: ImportantNoteToProfessionalType, index: number) => (
          <ImportantNotesInfoData>
            <div>{++index}.</div>
            <div>
              <p>{importantNote?.note}</p>
              <em>(year when this event occurred: {importantNote?.yearOfEvent})</em>
            </div>
          </ImportantNotesInfoData>
        )) : (
          <em>None</em>
        )}
    </ImportantNotesInfoWrapper>
  )
}

export default ImportantNotesInfo